export default function RelatedPrograms({ course }) {
  const programs = course?.relatedPrograms;

  const featured = programs[0];
  const others = programs.slice(1);

  return (
    <section id="related-programs" className="relative overflow-hidden bg-[#071A2F] py-20 text-white sm:py-24 lg:py-28">
      {/* giant decorative text */}
      <span aria-hidden="true"
        className="pointer-events-none absolute -right-8 top-2 select-none font-['Libre_Caslon_Display',Georgia,serif] text-[180px] leading-none text-white/[0.025] sm:text-[260px]">
        NEXT
      </span>

      <div className="relative mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">

        {/* HEADER */}
        <div className="grid gap-8 border-b border-white/15 pb-10 lg:grid-cols-[1fr_auto] lg:items-end">
          <div>
            <span className="flex items-center gap-3 text-sm font-bold uppercase tracking-[0.17em] text-[#D5AD57]">
              <span className="h-px w-10 bg-current" />
              Continue Exploring
            </span>

            <h2
              className="mt-6 max-w-[800px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(42px,5vw,68px)] font-normal leading-[1.03] tracking-[-0.04em]">
              Find another programme that{" "}
              <em className="font-normal text-[#D5AD57]">
                fits your ambition.
              </em>
            </h2>
          </div>

          <a href="/programmes"
            className="group inline-flex min-h-[54px] items-center gap-8 border border-white/20 px-6 text-sm font-bold uppercase tracking-[0.1em] transition hover:border-[#D5AD57] hover:text-[#D5AD57]">
            View All Programmes
            <span className="transition-transform group-hover:translate-x-1">
              →
            </span>
          </a>
        </div>

        {/* PROGRAM EXPLORER */}
        {featured && (
          <div className="mt-12 grid lg:grid-cols-[0.82fr_1.18fr]">

            {/* FEATURED */}
            <a href={featured.href}
              className="group relative flex min-h-[430px] flex-col justify-between overflow-hidden bg-[#8B1E3F] p-8 sm:p-10 lg:p-12">
              <span aria-hidden="true"
                className="absolute -bottom-20 -right-8 font-['Libre_Caslon_Display',Georgia,serif] text-[250px] leading-none text-white/[0.04]">
                01
              </span>

              <div className="relative">
                <div className="flex items-center justify-between">
                  <span className="text-xs font-bold uppercase tracking-[0.16em] text-[#D5AD57]">
                    Recommended Programme
                  </span>

                  <span className="text-sm text-white/40">01</span>
                </div>

                <div className="mt-16">
                  <span className="text-xs font-bold uppercase tracking-[0.14em] text-white/55">
                    {featured.school}
                  </span>

                  <h3
                    className="mt-4 max-w-[530px] font-['Libre_Caslon_Display',Georgia,serif] text-[36px] font-normal leading-[1.1] sm:text-[44px]">
                    {featured.title}
                  </h3>
                </div>
              </div>

              <div className="relative mt-12 flex items-end justify-between border-t border-white/20 pt-6">
                <div className="flex flex-wrap gap-x-7 gap-y-2 text-sm text-white/60">
                  <span>{featured.level}</span>
                  <span>{featured.duration}</span>
                </div>

                <span
                  className="grid h-12 w-12 place-items-center rounded-full border border-white/30 text-xl transition-all duration-300 group-hover:rotate-45 group-hover:border-[#D5AD57] group-hover:bg-[#D5AD57] group-hover:text-[#071A2F]">
                  ↗
                </span>
              </div>
            </a>

            {/* OTHER PROGRAMMES */}
            <div className="lg:pl-12 xl:pl-16">
              {others.map((program, index) => (
                <a key={program.title} href={program.href}
                  className="group grid gap-5 border-b border-white/15 py-8 first:border-t lg:grid-cols-[45px_1fr_auto] lg:items-center">
                  <span className="text-xs font-bold text-[#D5AD57]/60">
                    {String(index + 2).padStart(2, "0")}
                  </span>

                  <div>
                    <span className="text-[11px] font-bold uppercase tracking-[0.14em] text-[#D5AD57]">
                      {program.level} · {program.duration}
                    </span>

                    <h3
                      className="mt-2 font-['Libre_Caslon_Display',Georgia,serif] text-[25px] font-normal leading-[1.2] transition-colors group-hover:text-[#D5AD57] sm:text-[28px]">
                      {program.title}
                    </h3>

                    <span className="mt-2 block text-sm text-white/40">
                      {program.school}
                    </span>
                  </div>

                  <span
                    className="grid h-11 w-11 place-items-center rounded-full border border-white/15 text-lg transition-all group-hover:border-[#D5AD57] group-hover:text-[#D5AD57]">
                    ↗
                  </span>
                </a>
              ))}
            </div>
          </div>
        )}

        {/* FINAL NAVIGATION */}
        <div
          className="mt-14 flex flex-col gap-6 border-t border-white/15 pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="max-w-[570px] text-sm leading-7 text-white/45">
            Explore programmes across ISBM University and compare academic
            pathways based on your interests and career goals.
          </p>

          <div className="flex flex-wrap gap-6">
            <a href="/schools" className="text-sm font-bold text-white transition hover:text-[#D5AD57]">
              Explore Schools ↗
            </a>

            <a href="/admissions" className="text-sm font-bold text-[#D5AD57]">
              Admissions →
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}